export const getInitialState = () => ({
    message: "",
    type: "polite"
});
